import { InternalQuestion } from '@trupropel/vcp-commons';
import { useState } from 'react';

export interface MediaNoteAnswer {
  value: string;
  pictures: string[];
  isActive?: boolean;
}
export interface MediaNoteProps {
  question: InternalQuestion;
  note: string;
  notePlaceholder: string;
  onChange: (answer: MediaNoteAnswer) => void;
}

export type MediaNoteAnswerProps = MediaNoteAnswer;

export const useMediaNote = (props: MediaNoteProps) => {
  const [note, setNote] = useState<string>(props.note || '');
  const [pictures, setPictures] = useState<string[]>([]);

  const handleGalleryChange = (pictures) => {
    setPictures(pictures as string[]);
    props?.onChange?.({
      value: note,
      pictures: pictures,
    });
  };

  const handleNoteChange = (value) => {
    setNote(value as string);
    props?.onChange?.({
      value,
      pictures: pictures,
    });
  };

  return {
    note,
    pictures,
    handleGalleryChange,
    handleNoteChange,
  };
};
